import { c as _c } from "react/compiler-runtime";
import { Button, ButtonProps } from '@chakra-ui/react';
import React from 'react';
export const UserSearchToggleButton = props => {
  const $ = _c(9);
  let t0;
  if ($[0] !== props.isSelected) {
    t0 = props.isSelected ? {
      bgColor: "colorPalette.emphasized",
      color: "colorPalette.contrast",
      _hover: {
        borderColor: "colorPalette.border",
        bgColor: "colorPalette.emphasized"
      }
    } : {
      bgColor: "colorPalette.emphasized/50",
      color: "colorPalette.fg",
      _hover: {
        bgColor: "colorPalette.emphasized/50",
        borderColor: "colorPalette.emphasized"
      }
    };
    $[0] = props.isSelected;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = () => {
      props.onToggle(props.value);
    };
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = props.children || props.value?.title || props.value;
  let t3;
  if ($[4] !== props.buttonProps || $[5] !== t0 || $[6] !== t1 || $[7] !== t2) {
    t3 = <Button {...t0} borderRadius="md" paddingX="1em" size="sm" variant="outlineGhost" width="full" onClick={t1} {...props.buttonProps}>{t2}</Button>;
    $[4] = props.buttonProps;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};